import React from "react";

function QAAutomation() {
  return <div>QAAutomation</div>;
}

export default QAAutomation;
